import AppHeaderButton from '@/components/_common/AppHeaderButton';
import { APP_NAME } from '@/index';
import { Dropdown, Menu } from 'antd';
import React from 'react';
import { HelpCircle } from 'react-feather';

const HelpDropdownMenu: React.FC = () => {
  return (
    <Dropdown
      placement="bottom"
      overlay={
        <Menu>
          <Menu.Item>
            <a href="https://ajuda.ultracar.com.br/pt" target="_blank">
              Central de Ajuda
            </a>
          </Menu.Item>

          <Menu.Item>
            <a href={process.env.REACT_APP_SUPPORT_URL} target="_blank">
              Suporte {APP_NAME}
            </a>
          </Menu.Item>
        </Menu>
      }
    >
      <AppHeaderButton icon={<HelpCircle />} />
    </Dropdown>
  );
};

export default HelpDropdownMenu;
